import { Directive, computed, inject, input } from '@angular/core';
import { BrnAccordion } from '@spartan-ng/brain/accordion';
import { hlm } from '@spartan-ng/helm/utils';

import type { ClassValue } from 'clsx';

@Directive({
  selector: '[hlmAccordion], hlm-accordion',
  standalone: true,
  host: {
    '[class]': '_computedClass()',
  },
  hostDirectives: [{ directive: BrnAccordion, inputs: ['type', 'dir', 'orientation'] }],
})
export class HlmAccordionDirective {
  private readonly _brn = inject(BrnAccordion);

  // eslint-disable-next-line @angular-eslint/no-input-rename
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    hlm('flex', this._brn.orientation() === 'horizontal' ? 'flex-row' : 'flex-col', this.userClass()),
  );
}
